import React, { createContext, useContext, useState, useEffect } from 'react';

// Theme definitions - 10 Beautiful Themes
export const THEMES = {
  gaming: {
    id: 'gaming',
    name: 'Burnz Gaming',
    description: 'Dark theme with orange accents - Gaming platform style',
    preview: 'linear-gradient(135deg, #1A1A1A 0%, #FF4D00 100%)',
    colors: {
      background: '0 0% 6%',
      surface1: '#0F0F0F',
      surface2: '#1A1A1A',
      surface3: '#282828',
      surface4: '#333333',
      
      primary: '18 100% 50%',
      primaryHex: '#FF4D00',
      primaryLight: '#FF6B33',
      primaryDark: '#CC3D00',
      
      secondary: '270 100% 50%',
      secondaryHex: '#9F00FF',
      secondaryLight: '#B84DFF',
      secondaryDark: '#7700CC',
      
      accent: '168 100% 50%',
      accentHex: '#00FFD1',
      
      success: '#00E676',
      warning: '#FFC107',
      error: '#DC3545',
      info: '#00E5FF',
      
      textPrimary: '#FFFFFF',
      textSecondary: '#B3B3B3',
      textMuted: '#666666',
      
      border: 'rgba(255, 255, 255, 0.08)',
      borderHover: 'rgba(255, 77, 0, 0.4)',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #FF4D00 0%, #FF6B33 100%)',
      secondary: 'linear-gradient(135deg, #9F00FF 0%, #7700CC 100%)',
      fire: 'linear-gradient(135deg, #FF4D00, #FF0080, #9F00FF)',
      card: 'linear-gradient(135deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.01) 100%)',
      ambient: 'radial-gradient(circle at 20% 20%, rgba(255, 77, 0, 0.08) 0%, transparent 40%)',
    },
    effects: {
      glowPrimary: '0 0 20px rgba(255, 77, 0, 0.4), 0 0 40px rgba(255, 77, 0, 0.2)',
      glowSecondary: '0 0 20px rgba(159, 0, 255, 0.4), 0 0 40px rgba(159, 0, 255, 0.2)',
      cardHover: '0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 77, 0, 0.1)',
    }
  },
  
  union: {
    id: 'union',
    name: 'Burnz Union',
    description: 'Original orange & purple - Community style',
    preview: 'linear-gradient(135deg, #0D0D0D 0%, #FF6600 100%)',
    colors: {
      background: '0 0% 5%',
      surface1: '#0D0D0D',
      surface2: '#1A1A1A',
      surface3: '#222222',
      surface4: '#2A2A2A',
      
      primary: '24 100% 50%',
      primaryHex: '#FF6600',
      primaryLight: '#FF8533',
      primaryDark: '#CC5200',
      
      secondary: '270 70% 50%',
      secondaryHex: '#8A2BE2',
      secondaryLight: '#9D4EDD',
      secondaryDark: '#6B21A8',
      
      accent: '270 70% 50%',
      accentHex: '#8A2BE2',
      
      success: '#00E676',
      warning: '#FFD700',
      error: '#FF1744',
      info: '#00E5FF',
      
      textPrimary: '#FFFFFF',
      textSecondary: 'rgba(255, 255, 255, 0.7)',
      textMuted: 'rgba(255, 255, 255, 0.4)',
      
      border: 'rgba(255, 255, 255, 0.06)',
      borderHover: 'rgba(255, 102, 0, 0.3)',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #FF6600 0%, #FF8533 100%)',
      secondary: 'linear-gradient(135deg, #8A2BE2 0%, #6B21A8 100%)',
      fire: 'linear-gradient(135deg, #FF6600, #FF0080, #8A2BE2)',
      card: 'linear-gradient(135deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.01) 100%)',
      ambient: 'radial-gradient(circle at 20% 20%, rgba(255, 102, 0, 0.08) 0%, transparent 40%)',
    },
    effects: {
      glowPrimary: '0 0 20px rgba(255, 102, 0, 0.4), 0 0 40px rgba(255, 102, 0, 0.2)',
      glowSecondary: '0 0 20px rgba(138, 43, 226, 0.4), 0 0 40px rgba(138, 43, 226, 0.2)',
      cardHover: '0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 102, 0, 0.1)',
    }
  },
  
  midnight: {
    id: 'midnight',
    name: 'Midnight Blue',
    description: 'Deep blue with cyan accents - Cool tone',
    preview: 'linear-gradient(135deg, #0A0F1A 0%, #00B4D8 100%)',
    colors: {
      background: '220 50% 5%',
      surface1: '#0A0F1A',
      surface2: '#141B2D',
      surface3: '#1E2740',
      surface4: '#283352',
      
      primary: '195 100% 50%',
      primaryHex: '#00B4D8',
      primaryLight: '#48CAE4',
      primaryDark: '#0096C7',
      
      secondary: '260 80% 60%',
      secondaryHex: '#7B68EE',
      secondaryLight: '#9683FF',
      secondaryDark: '#5B4BC7',
      
      accent: '168 100% 50%',
      accentHex: '#00FFD1',
      
      success: '#00E676',
      warning: '#FFD93D',
      error: '#FF6B6B',
      info: '#48CAE4',
      
      textPrimary: '#FFFFFF',
      textSecondary: '#90CAF9',
      textMuted: '#5C7599',
      
      border: 'rgba(144, 202, 249, 0.1)',
      borderHover: 'rgba(0, 180, 216, 0.4)',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #00B4D8 0%, #48CAE4 100%)',
      secondary: 'linear-gradient(135deg, #7B68EE 0%, #5B4BC7 100%)',
      fire: 'linear-gradient(135deg, #00B4D8, #7B68EE, #00FFD1)',
      card: 'linear-gradient(135deg, rgba(144, 202, 249, 0.04) 0%, rgba(144, 202, 249, 0.01) 100%)',
      ambient: 'radial-gradient(circle at 20% 20%, rgba(0, 180, 216, 0.08) 0%, transparent 40%)',
    },
    effects: {
      glowPrimary: '0 0 20px rgba(0, 180, 216, 0.4), 0 0 40px rgba(0, 180, 216, 0.2)',
      glowSecondary: '0 0 20px rgba(123, 104, 238, 0.4), 0 0 40px rgba(123, 104, 238, 0.2)',
      cardHover: '0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(0, 180, 216, 0.1)',
    }
  },
  
  emerald: {
    id: 'emerald',
    name: 'Emerald Night',
    description: 'Deep green with gold accents - Nature theme',
    preview: 'linear-gradient(135deg, #0D1912 0%, #10B981 100%)',
    colors: {
      background: '150 30% 5%',
      surface1: '#0D1912',
      surface2: '#142620',
      surface3: '#1B332B',
      surface4: '#234137',
      
      primary: '160 84% 39%',
      primaryHex: '#10B981',
      primaryLight: '#34D399',
      primaryDark: '#059669',
      
      secondary: '45 100% 50%',
      secondaryHex: '#FFD700',
      secondaryLight: '#FFE033',
      secondaryDark: '#CCAC00',
      
      accent: '160 84% 39%',
      accentHex: '#10B981',
      
      success: '#34D399',
      warning: '#FFD700',
      error: '#F87171',
      info: '#60A5FA',
      
      textPrimary: '#FFFFFF',
      textSecondary: '#A7F3D0',
      textMuted: '#6B8F7F',
      
      border: 'rgba(167, 243, 208, 0.1)',
      borderHover: 'rgba(16, 185, 129, 0.4)',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #10B981 0%, #34D399 100%)',
      secondary: 'linear-gradient(135deg, #FFD700 0%, #CCAC00 100%)',
      fire: 'linear-gradient(135deg, #10B981, #FFD700, #34D399)',
      card: 'linear-gradient(135deg, rgba(167, 243, 208, 0.04) 0%, rgba(167, 243, 208, 0.01) 100%)',
      ambient: 'radial-gradient(circle at 20% 20%, rgba(16, 185, 129, 0.08) 0%, transparent 40%)',
    },
    effects: {
      glowPrimary: '0 0 20px rgba(16, 185, 129, 0.4), 0 0 40px rgba(16, 185, 129, 0.2)',
      glowSecondary: '0 0 20px rgba(255, 215, 0, 0.4), 0 0 40px rgba(255, 215, 0, 0.2)',
      cardHover: '0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(16, 185, 129, 0.1)',
    }
  },
  
  crimson: {
    id: 'crimson',
    name: 'Crimson Blaze',
    description: 'Deep red with gold accents - Bold and intense',
    preview: 'linear-gradient(135deg, #1A0A0A 0%, #DC2626 100%)',
    colors: {
      background: '0 50% 5%',
      surface1: '#1A0A0A',
      surface2: '#2A1414',
      surface3: '#3D1F1F',
      surface4: '#4F2929',
      
      primary: '0 84% 50%',
      primaryHex: '#DC2626',
      primaryLight: '#EF4444',
      primaryDark: '#B91C1C',
      
      secondary: '45 100% 50%',
      secondaryHex: '#FFD700',
      secondaryLight: '#FFE033',
      secondaryDark: '#CCAC00',
      
      accent: '0 84% 50%',
      accentHex: '#DC2626',
      
      success: '#22C55E',
      warning: '#FFD700',
      error: '#EF4444',
      info: '#3B82F6',
      
      textPrimary: '#FFFFFF',
      textSecondary: '#FECACA',
      textMuted: '#9F7474',
      
      border: 'rgba(254, 202, 202, 0.1)',
      borderHover: 'rgba(220, 38, 38, 0.4)',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #DC2626 0%, #EF4444 100%)',
      secondary: 'linear-gradient(135deg, #FFD700 0%, #CCAC00 100%)',
      fire: 'linear-gradient(135deg, #DC2626, #FFD700, #EF4444)',
      card: 'linear-gradient(135deg, rgba(254, 202, 202, 0.04) 0%, rgba(254, 202, 202, 0.01) 100%)',
      ambient: 'radial-gradient(circle at 20% 20%, rgba(220, 38, 38, 0.08) 0%, transparent 40%)',
    },
    effects: {
      glowPrimary: '0 0 20px rgba(220, 38, 38, 0.4), 0 0 40px rgba(220, 38, 38, 0.2)',
      glowSecondary: '0 0 20px rgba(255, 215, 0, 0.4), 0 0 40px rgba(255, 215, 0, 0.2)',
      cardHover: '0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(220, 38, 38, 0.1)',
    }
  },

  // NEW THEMES
  
  neon: {
    id: 'neon',
    name: 'Neon Cyber',
    description: 'Vibrant neon pink & cyan - Cyberpunk style',
    preview: 'linear-gradient(135deg, #0D0D1A 0%, #FF00FF 50%, #00FFFF 100%)',
    colors: {
      background: '240 30% 5%',
      surface1: '#0D0D1A',
      surface2: '#151528',
      surface3: '#1D1D38',
      surface4: '#252548',
      
      primary: '300 100% 50%',
      primaryHex: '#FF00FF',
      primaryLight: '#FF66FF',
      primaryDark: '#CC00CC',
      
      secondary: '180 100% 50%',
      secondaryHex: '#00FFFF',
      secondaryLight: '#66FFFF',
      secondaryDark: '#00CCCC',
      
      accent: '60 100% 50%',
      accentHex: '#FFFF00',
      
      success: '#00FF88',
      warning: '#FFFF00',
      error: '#FF0066',
      info: '#00FFFF',
      
      textPrimary: '#FFFFFF',
      textSecondary: '#E0E0FF',
      textMuted: '#8080AA',
      
      border: 'rgba(255, 0, 255, 0.15)',
      borderHover: 'rgba(0, 255, 255, 0.4)',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #FF00FF 0%, #FF66FF 100%)',
      secondary: 'linear-gradient(135deg, #00FFFF 0%, #00CCCC 100%)',
      fire: 'linear-gradient(135deg, #FF00FF, #00FFFF, #FFFF00)',
      card: 'linear-gradient(135deg, rgba(255, 0, 255, 0.05) 0%, rgba(0, 255, 255, 0.02) 100%)',
      ambient: 'radial-gradient(circle at 20% 20%, rgba(255, 0, 255, 0.1) 0%, transparent 40%)',
    },
    effects: {
      glowPrimary: '0 0 20px rgba(255, 0, 255, 0.5), 0 0 40px rgba(255, 0, 255, 0.3)',
      glowSecondary: '0 0 20px rgba(0, 255, 255, 0.5), 0 0 40px rgba(0, 255, 255, 0.3)',
      cardHover: '0 8px 32px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 0, 255, 0.2)',
    }
  },

  sunset: {
    id: 'sunset',
    name: 'Sunset Vibes',
    description: 'Warm orange to pink gradient - Relaxed style',
    preview: 'linear-gradient(135deg, #1A1010 0%, #FF6B35 50%, #F7567C 100%)',
    colors: {
      background: '10 30% 6%',
      surface1: '#1A1010',
      surface2: '#2A1A1A',
      surface3: '#3A2525',
      surface4: '#4A3030',
      
      primary: '20 100% 60%',
      primaryHex: '#FF6B35',
      primaryLight: '#FF8F5A',
      primaryDark: '#E65A2A',
      
      secondary: '345 91% 65%',
      secondaryHex: '#F7567C',
      secondaryLight: '#FF7A99',
      secondaryDark: '#E54066',
      
      accent: '40 100% 60%',
      accentHex: '#FFB347',
      
      success: '#4CAF50',
      warning: '#FFB347',
      error: '#F7567C',
      info: '#64B5F6',
      
      textPrimary: '#FFFFFF',
      textSecondary: '#FFD4C4',
      textMuted: '#A08080',
      
      border: 'rgba(255, 107, 53, 0.15)',
      borderHover: 'rgba(247, 86, 124, 0.4)',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #FF6B35 0%, #F7567C 100%)',
      secondary: 'linear-gradient(135deg, #F7567C 0%, #E54066 100%)',
      fire: 'linear-gradient(135deg, #FF6B35, #F7567C, #FFB347)',
      card: 'linear-gradient(135deg, rgba(255, 107, 53, 0.05) 0%, rgba(247, 86, 124, 0.02) 100%)',
      ambient: 'radial-gradient(circle at 20% 20%, rgba(255, 107, 53, 0.1) 0%, transparent 40%)',
    },
    effects: {
      glowPrimary: '0 0 20px rgba(255, 107, 53, 0.4), 0 0 40px rgba(255, 107, 53, 0.2)',
      glowSecondary: '0 0 20px rgba(247, 86, 124, 0.4), 0 0 40px rgba(247, 86, 124, 0.2)',
      cardHover: '0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 107, 53, 0.1)',
    }
  },

  arctic: {
    id: 'arctic',
    name: 'Arctic Frost',
    description: 'Icy white & blue - Clean minimal style',
    preview: 'linear-gradient(135deg, #0F1419 0%, #E1F5FE 100%)',
    colors: {
      background: '210 20% 8%',
      surface1: '#0F1419',
      surface2: '#1A2633',
      surface3: '#25364D',
      surface4: '#304766',
      
      primary: '200 100% 70%',
      primaryHex: '#64B5F6',
      primaryLight: '#90CAF9',
      primaryDark: '#42A5F5',
      
      secondary: '200 20% 90%',
      secondaryHex: '#E1E8ED',
      secondaryLight: '#F5F8FA',
      secondaryDark: '#C4CED6',
      
      accent: '180 60% 60%',
      accentHex: '#4DD0E1',
      
      success: '#69F0AE',
      warning: '#FFD54F',
      error: '#FF5252',
      info: '#64B5F6',
      
      textPrimary: '#FFFFFF',
      textSecondary: '#B0BEC5',
      textMuted: '#607D8B',
      
      border: 'rgba(100, 181, 246, 0.15)',
      borderHover: 'rgba(100, 181, 246, 0.4)',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #64B5F6 0%, #90CAF9 100%)',
      secondary: 'linear-gradient(135deg, #E1E8ED 0%, #C4CED6 100%)',
      fire: 'linear-gradient(135deg, #64B5F6, #4DD0E1, #E1E8ED)',
      card: 'linear-gradient(135deg, rgba(100, 181, 246, 0.04) 0%, rgba(225, 232, 237, 0.02) 100%)',
      ambient: 'radial-gradient(circle at 20% 20%, rgba(100, 181, 246, 0.08) 0%, transparent 40%)',
    },
    effects: {
      glowPrimary: '0 0 20px rgba(100, 181, 246, 0.4), 0 0 40px rgba(100, 181, 246, 0.2)',
      glowSecondary: '0 0 20px rgba(225, 232, 237, 0.3), 0 0 40px rgba(225, 232, 237, 0.1)',
      cardHover: '0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(100, 181, 246, 0.1)',
    }
  },

  royal: {
    id: 'royal',
    name: 'Royal Purple',
    description: 'Deep purple with gold - Luxurious style',
    preview: 'linear-gradient(135deg, #1A0A2E 0%, #6B21A8 50%, #FFD700 100%)',
    colors: {
      background: '270 50% 8%',
      surface1: '#1A0A2E',
      surface2: '#2D1B47',
      surface3: '#402C60',
      surface4: '#533D79',
      
      primary: '270 70% 40%',
      primaryHex: '#6B21A8',
      primaryLight: '#8B5CF6',
      primaryDark: '#5B21B6',
      
      secondary: '45 100% 50%',
      secondaryHex: '#FFD700',
      secondaryLight: '#FFE44D',
      secondaryDark: '#CCAC00',
      
      accent: '320 80% 50%',
      accentHex: '#E040FB',
      
      success: '#4CAF50',
      warning: '#FFD700',
      error: '#EF5350',
      info: '#7C4DFF',
      
      textPrimary: '#FFFFFF',
      textSecondary: '#D1C4E9',
      textMuted: '#9575CD',
      
      border: 'rgba(139, 92, 246, 0.15)',
      borderHover: 'rgba(255, 215, 0, 0.4)',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #6B21A8 0%, #8B5CF6 100%)',
      secondary: 'linear-gradient(135deg, #FFD700 0%, #CCAC00 100%)',
      fire: 'linear-gradient(135deg, #6B21A8, #E040FB, #FFD700)',
      card: 'linear-gradient(135deg, rgba(139, 92, 246, 0.05) 0%, rgba(255, 215, 0, 0.02) 100%)',
      ambient: 'radial-gradient(circle at 20% 20%, rgba(139, 92, 246, 0.1) 0%, transparent 40%)',
    },
    effects: {
      glowPrimary: '0 0 20px rgba(139, 92, 246, 0.5), 0 0 40px rgba(139, 92, 246, 0.3)',
      glowSecondary: '0 0 20px rgba(255, 215, 0, 0.4), 0 0 40px rgba(255, 215, 0, 0.2)',
      cardHover: '0 8px 32px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(139, 92, 246, 0.2)',
    }
  },

  matrix: {
    id: 'matrix',
    name: 'Matrix Green',
    description: 'Hacker green on black - Tech style',
    preview: 'linear-gradient(135deg, #000000 0%, #00FF41 100%)',
    colors: {
      background: '0 0% 3%',
      surface1: '#050505',
      surface2: '#0A0A0A',
      surface3: '#121212',
      surface4: '#1A1A1A',
      
      primary: '120 100% 50%',
      primaryHex: '#00FF41',
      primaryLight: '#66FF8C',
      primaryDark: '#00CC34',
      
      secondary: '120 60% 30%',
      secondaryHex: '#1F8C3E',
      secondaryLight: '#2DAF50',
      secondaryDark: '#156B2E',
      
      accent: '120 100% 50%',
      accentHex: '#00FF41',
      
      success: '#00FF41',
      warning: '#FFFF00',
      error: '#FF0040',
      info: '#00FF41',
      
      textPrimary: '#00FF41',
      textSecondary: '#00CC34',
      textMuted: '#008F24',
      
      border: 'rgba(0, 255, 65, 0.1)',
      borderHover: 'rgba(0, 255, 65, 0.3)',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #00FF41 0%, #00CC34 100%)',
      secondary: 'linear-gradient(135deg, #1F8C3E 0%, #156B2E 100%)',
      fire: 'linear-gradient(135deg, #00FF41, #00CC34, #008F24)',
      card: 'linear-gradient(135deg, rgba(0, 255, 65, 0.03) 0%, rgba(0, 255, 65, 0.01) 100%)',
      ambient: 'radial-gradient(circle at 20% 20%, rgba(0, 255, 65, 0.05) 0%, transparent 40%)',
    },
    effects: {
      glowPrimary: '0 0 20px rgba(0, 255, 65, 0.5), 0 0 40px rgba(0, 255, 65, 0.3), 0 0 60px rgba(0, 255, 65, 0.1)',
      glowSecondary: '0 0 20px rgba(31, 140, 62, 0.4), 0 0 40px rgba(31, 140, 62, 0.2)',
      cardHover: '0 8px 32px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(0, 255, 65, 0.2)',
    }
  }
};

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    const saved = localStorage.getItem('burnz-theme');
    return saved && THEMES[saved] ? saved : 'gaming';
  });
  
  const theme = THEMES[currentTheme];
  
  // Apply theme CSS variables
  useEffect(() => {
    const root = document.documentElement;
    const t = theme.colors;
    
    // Core CSS variables
    root.style.setProperty('--background', t.background);
    root.style.setProperty('--surface-1', t.surface1);
    root.style.setProperty('--surface-2', t.surface2);
    root.style.setProperty('--surface-3', t.surface3);
    root.style.setProperty('--surface-4', t.surface4);
    
    root.style.setProperty('--primary', t.primary);
    root.style.setProperty('--burnz-orange', t.primaryHex);
    root.style.setProperty('--burnz-orange-light', t.primaryLight);
    root.style.setProperty('--burnz-orange-dark', t.primaryDark);
    
    root.style.setProperty('--secondary', t.secondary);
    root.style.setProperty('--burnz-purple', t.secondaryHex);
    root.style.setProperty('--burnz-purple-light', t.secondaryLight);
    root.style.setProperty('--burnz-purple-dark', t.secondaryDark);
    
    root.style.setProperty('--accent', t.accent);
    root.style.setProperty('--burnz-cyan', t.accentHex);
    
    root.style.setProperty('--burnz-green', t.success);
    root.style.setProperty('--burnz-gold', t.warning);
    root.style.setProperty('--burnz-red', t.error);
    
    root.style.setProperty('--text-primary', t.textPrimary);
    root.style.setProperty('--text-secondary', t.textSecondary);
    root.style.setProperty('--text-muted', t.textMuted);
    
    root.style.setProperty('--border', t.border);
    root.style.setProperty('--ring', t.primary);
    
    // Store in localStorage
    localStorage.setItem('burnz-theme', currentTheme);
  }, [currentTheme, theme]);
  
  const changeTheme = (themeId) => {
    if (THEMES[themeId]) {
      setCurrentTheme(themeId);
    }
  };
  
  return (
    <ThemeContext.Provider value={{ 
      currentTheme, 
      theme, 
      changeTheme,
      themes: THEMES 
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
